<template>
  <div>
    <AdminNavbar />
    <div v-if="!entriesLoaded">
      <div class="d-flex justify-content-center">
        <div class="col col-sm-8 col-md-6">
          <LoadingBar />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="pt-3 container">
        <div v-if="getAllEntries" class="text-start">
          <!-- Population Badge -->
          <div class="d-flex mb-3">
            <div class="fw-bold fs-4">
              <div
                class="bg-white rounded-5 ps-3 pe-2 py-2 border border-2 border-primary"
              >
                <i class="bi-people-fill"></i> Total Users
                <span class="ms-2 bg-primary text-white rounded-5 px-2">{{
                  entries.length
                }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <TeamBreakdown
                title="Damright"
                icon="group1.png"
                group="group0"
                :entries="damwright"
              />
            </div>
            <div class="col">
              <TeamBreakdown
                title="Howlmoor"
                icon="group2.png"
                group="group1"
                :entries="howlmoor"
              />
            </div>
            <div class="col">
              <TeamBreakdown
                title="Ironjaw"
                icon="group3.png"
                group="group2"
                :entries="ironjaw"
              />
            </div>
            <div class="col">
              <TeamBreakdown
                title="Timberblast"
                icon="group4.png"
                group="group3"
                :entries="timberblast"
              />
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-3">
              <TeamBreakdown
                title="&nbsp;&nbsp;&nbsp;Unassociated"
                :entries="unassociated"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import AdminNavbar from "@/admin/components/AdminNavbar.vue";
import LoadingBar from "@/components/ui/LoadingBar.vue";
import TeamBreakdown from "@/components/TeamBreakdown.vue";

export default {
  name: "AdminView",
  components: {
    AdminNavbar,
    LoadingBar,
    TeamBreakdown
  },
  computed: {
    ...mapGetters("datastore", ["getAllEntries"]),
    ...mapState("datastore", ["entriesLoaded"]),
    entries() {
      let _entries = JSON.parse(JSON.stringify([...this.getAllEntries]));
      _entries = _entries.map((entry) => {
        try {
          entry.value = JSON.parse(entry.value);
        } catch (e) {
          entry.value = {};
        }

        return entry;
      });

      return _entries;
    },
    damwright() {
      return this.entries.filter((entry) => {
        return entry.value.groupId === "group0";
      });
    },
    howlmoor() {
      return this.entries.filter((entry) => {
        return entry.value.groupId === "group1";
      });
    },
    ironjaw() {
      return this.entries.filter((entry) => {
        return entry.value.groupId === "group2";
      });
    },
    timberblast() {
      return this.entries.filter((entry) => {
        return entry.value.groupId === "group3";
      });
    },
    unassociated() {
      return this.entries.filter((entry) => {
        return !entry.value?.groupId;
      });
    }
  }
};
</script>
